import React, { useState, useEffect } from "react";

import Request from "../../core/httpClient";
import CommonAreaForm from "./CommonAreaForm";
const request = new Request();



const CommonAreasEdit = ({ area, subfraccionamientos, subLabel, updateData }) => {
	// Estado inicial basado en props
	const [state, setState] = useState({
		showModal: false,
		nombre: area.nombre,
		descripcion: area.descripcion,
		activo: area.activo,
		id: area.id_espacio,
		categoria: area.id_categoria,
		diasPrevios: area.dias_reserva,
		minutosPrevios: area.minutos_previos_reserva,
		fianza: area.fianza,
		tiempoDisponible: area.dias_maximos_reserva ? area.dias_maximos_reserva : area.horas_maximas_reserva,
		isDiasDisponible: area.dias_maximos_reserva ? true : false,
		imagenArea: area.area_imagen || "",
		idSubfrac: area.id_subfraccionamiento || null,
		subfraccionamientos,
		categories: [],
		anuales: area.max_reservas_anual,
		mensuales: area.max_reservas_mensual,
		diarias: area.max_reservas_diaria,
		consecutivas: area.max_reservas_consecutivas,
		aforo: area.max_aforo || 1,
		pausar: area.pausar !== null && area.pausar !== 0 ? 1 : 0,
		motivo: area.motivo || "",
		aforoMax: area.max_aforo !== null ? true : false,
		maXVivienda: area.max_reservas_aforo !== null ? area.max_reservas_aforo : 1,
		subLabel
	});

	// Helper para actualizar estado y notificar al padre
	const handleUpdate = (data) => {
		updateData(data);
		setState((prev) => ({ ...prev, ...data }));
	};

	// Equivalente a componentDidUpdate para cambios en props.area
	useEffect(() => {
		setState((prev) => ({
			...prev,
			id: area.id_espacio,
			nombre: area.nombre,
			descripcion: area.descripcion,
			activo: area.activo,
			categoria: area.id_categoria,
			diasPrevios: area.dias_reserva,
			minutosPrevios: area.minutos_previos_reserva,
			fianza: area.fianza,
			tiempoDisponible: area.dias_maximos_reserva ? area.dias_maximos_reserva : area.horas_maximas_reserva,
			isDiasDisponible: area.dias_maximos_reserva ? true : false,
			imagenArea: area.area_imagen || "",
			idSubfrac: area.id_subfraccionamiento || null,
			anuales: area.max_reservas_anual || "",
			mensuales: area.max_reservas_mensual || "",
			diarias: area.max_reservas_diaria || "",
			consecutivas: area.max_reservas_consecutivas || "",
			aforo: area.max_aforo || 1,
			aforoMax: area.max_aforo !== null ? true : false,
			maXVivienda: area.max_reservas_aforo !== null ? area.max_reservas_aforo : 1,
			pausar: area.pausar,
			motivo: area.motivo || ""
		}));
		// convertir imagen base64 a URL
		if (area.area_imagen) {
			base64ToUrl({ area_imagen: area.area_imagen, id_area: area.id_espacio });
		}
	}, [area]);

	// Función para cargar categorías
	const getCategories = async () => {
		try {
			const data = { id: localStorage.getItem("frac") };
			const response = await request.post("/commonArea/get/categories", data);
			if (response && !response.error && response.categories && !response.empty) {
				setState((prev) => ({ ...prev, categories: response.categories }));
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getCategories();
	}, []);

	// Preview de imagen
	const showPreviewImageCommon = (e) => {
		const file = e.target.files[0];
		if (!file) return;
		const reader = new FileReader();
		reader.onloadend = () => {
			handleUpdate({ imagenArea: reader.result });
		};
		reader.readAsDataURL(file);
	};

	const [eine1, setEine1] = useState("");
	const [eine2, setEine2] = useState("");

	const base64ToUrl = async (info) => {
		try {
			const data = {
				img: info.area_imagen,
				idfrac: localStorage.getItem("frac") || 0,
				id: info.id_area,
				module: "areasComunes",
			};

			const response = await request.post("/commonArea/base64ToUrl", data);

			if (response && !response.error) {
				if (info.type === 1) {
					setEine1(response.url);
				}
				if (info.type === 2) {
					setEine2(response.url);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	// Render
	return (
		<CommonAreaForm
			state={state}
			handleUpdate={handleUpdate}
			showPreviewImageCommon={showPreviewImageCommon}
			submitText="ACTUALIZAR"
		/>
	);


};

export default CommonAreasEdit;
